module.exports = __webpack_public_path__ + "img/icon_m_add.b54f61d7.svg";